import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    behavior: { type: String, default: 'smooth' },
    block: { type: String, default: 'center' },
    scrollToId: String
  }

  connect() {
    if (!this.hasScrollToIdValue) {
      return
    }

    const targetElement = document.getElementById(this.scrollToIdValue)
    targetElement.scrollIntoView({
      behavior: this.behaviorValue,
      block: this.blockValue
    })
  }
}
